import React from "react";
import "./Terms.css";
const Terms: React.FC = () => {
  return (
    <>
      {
        <div className="terms-text">
          By continuing, you agree to Streamoid's{" "}
          <a href="/terms-and-conditions" target="_blank">
            Terms of Service
          </a>{" "}
          <br />
          and acknowledge the{" "}
          <a href="/privacy" target="_blank">
            Privacy Policy.
          </a>
          <br />
          <div>
            <a href="/returns" target="_blank">
              Returns
            </a>{" "}
            and{" "}
            <a href="/cookies" target="_blank">
              Cookies
            </a>
          </div>
        </div>
      }
    </>
  );
};

export default Terms;
